import axios from "axios";
import { toast } from "./SnackBarUtils";
import eventBus from "./EventBus";
import { socket } from "./socket";


const clearStorage = () => {
  localStorage.removeItem(
    `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`
  );
  localStorage.removeItem(
    `${process.env.REACT_APP_COGNITO_CLIENT_ID}.signedIn`
  );
  return;
};

const request = async (req, method = null, body = null, retried = false) => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`
  );

  const headers = {
    Accesstoken: token,
  };
  let result;
  let error;

  //GET request
  if (!method) {
    try {
      result = await axios.get(`${process.env.REACT_APP_TNFT_SERVER}/${req}`, {
        headers: headers,
        cache: "no-store",
      });
      const newToken = result.headers["x-access-token"];
      if (newToken) {
        localStorage.setItem(
          `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`,
          newToken
        );
      }
      return result.data;
    } catch (e) {
      if (e.response?.status === 303) {
        const newToken = e.response.headers["x-access-token"];
        if (newToken) {
          localStorage.setItem(
            `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`,
            newToken
          );
           socket.auth.token = newToken;
          if (socket.connected) {
            socket.disconnect().connect();
          }
        }
        const { requireMessageAck, requireTermsAck } = e.response.data || {};
        if (requireMessageAck || requireTermsAck) {
          if (requireMessageAck)
            localStorage.setItem("requireMessageAck", "true");
          if (requireTermsAck) localStorage.setItem("requireTermsAck", "true");
          eventBus.emit("SHOW_SYSTEM_MESSAGE", {
            requireMessageAck,
            requireTermsAck,
          });
          return;
        }
      } else if (e.response?.status === 402) {
        const { orgId, accessToken } = e.response.data || {};
        if (accessToken) {
          localStorage.setItem(`${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`, accessToken);
          socket.auth.token = accessToken;
          if (socket.connected) socket.disconnect().connect();
        }
        localStorage.setItem("paymentRequired", "true");
        if (orgId) localStorage.setItem("paymentOrgId", orgId);
        eventBus.emit("PAYMENT_REQUIRED", { orgId });
        return { success: false, paymentRequired: true };
      } else if (e.response.status === 401) {
        console.error("Not authorized. Signing out");
        toast.error("You have been logged out.");
        clearStorage();
        window.location.reload();
        return;
      }
      if (e?.response?.data?.error) {
        error = e?.response?.data?.error;
      } else {
        error = `Error getting ${req}. Status code: ${e.response.status}. Error: ${e.message}`;
      }
      console.error(error);
      toast.error(error);
      return e.response.data;
    }
  } else if (method === "post") {
    try {
      result = await axios.post(
        `${process.env.REACT_APP_TNFT_SERVER}/${req}`,
        body,
        { headers: headers }
      );
      const newToken = result.headers["x-access-token"];
      if (newToken) {
        localStorage.setItem(
          `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`,
          newToken
        );
      }
      return result.data;
    } catch (e) {
      if (e.response?.status === 303) {
        const newToken = e.response.headers["x-access-token"];
        if (newToken) {
          localStorage.setItem(
            `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`,
            newToken
          );
           socket.auth.token = newToken;
          if (socket.connected) {
            socket.disconnect().connect();
          }
        }
        const { requireMessageAck, requireTermsAck } = e.response.data || {};
        if (requireMessageAck || requireTermsAck) {
           if (requireMessageAck)
            localStorage.setItem("requireMessageAck", "true");
          if (requireTermsAck) localStorage.setItem("requireTermsAck", "true");
          eventBus.emit("SHOW_SYSTEM_MESSAGE", {
            requireMessageAck,
            requireTermsAck,
          });
          return;
        }
      } else if (e.response?.status === 402) {
        const { orgId, accessToken } = e.response.data || {};
        if (accessToken) {
          localStorage.setItem(`${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`, accessToken);
          socket.auth.token = accessToken;
          if (socket.connected) socket.disconnect().connect();
        }
        localStorage.setItem("paymentRequired", "true");
        if (orgId) localStorage.setItem("paymentOrgId", orgId);
        eventBus.emit("PAYMENT_REQUIRED", { orgId });
        return { success: false, paymentRequired: true };
      } else if (e.response.status === 401) {
        toast.error("You have been logged out.");
        clearStorage();
        window.location.reload();
        return;
      } else if (e.response.status === 404) {
        error = "Looks like this request is unknown;";
        console.error(error);
        toast.error(error);
        return;
      }
      // let error = `Error posting ${req}: ${e.message}`
      // console.error(error);
      // alert(error)
      // alert(e.response.data?.error);
      toast.error(e.response.data?.error);
      return e.response.data;
    }
  }
};
export default request;
